import script from "./checkout-confirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./checkout-confirmation.vue?vue&type=script&setup=true&lang=js"

import "./checkout-confirmation.vue?vue&type=style&index=0&id=11730a51&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11730a51"]])

export default __exports__